const BlockAccordeonSimple = ($) => {
  let accordions = [];
  const accordionsCtn = $(".wp-block-seven-shapes-accordeon-simple");

  $(window).on("load", function () {
    accordionsCtn.each((i, accordion) => {
      accordions[i] = new AccordionSimple(accordion, $);
    });
  });
};

export default BlockAccordeonSimple;

class AccordionSimple {
  constructor(domNode, $) {
    this.width = 0;
    this.height = 0;
    this.block = domNode;
    this.triggers = this.block.querySelectorAll(
      ".wp-block-seven-shapes-accordeon-simple__trigger"
    );
    this.panels = this.block.querySelectorAll(
      ".wp-block-seven-shapes-accordeon-simple__panel"
    );
    this.panelsInner = this.block.querySelectorAll(
      ".wp-block-seven-shapes-accordeon-simple__panel-inner"
    );
    this.nbItems = this.panels.length;

    $(this.triggers).on("click", (e) => this.onClickTrigger(e, $));

    this.init($);
    $(window).on(
      "resize",
      function () {
        this.init($);
      }.bind(this)
    );

    $(document).on(
      "gform_post_render",
      function (event, form_id, current_page) {
        // console.log({event, form_id, current_page});
        this.init($);
      }.bind(this)
    );
  }

  init($) {
    // reset sizes
    $(this.panels).removeAttr("style");
    $(this.panelsInner).removeAttr("style");
    $(this.triggers).removeAttr("style");
    $(this.block)
      .find(".wp-block-seven-shapes-accordeon-simple__panel--hidden")
      .find("button, [href], input, select, textarea")
      .attr("tabIndex", "-1");

    const currentPanel = $(this.panels).not(
      ".wp-block-seven-shapes-accordeon-simple__panel--hidden"
    );
    const currentPanelHeight = currentPanel
      .find(".wp-block-seven-shapes-accordeon-simple__panel-inner")
      .outerHeight();
    currentPanel.css({ flexBasis: currentPanelHeight });

    $(this.panels).css({ overflow: `hidden` });
    $(
      this.block.querySelectorAll(
        ".wp-block-seven-shapes-accordeon-simple__panel--hidden"
      )
    ).css({ flexBasis: 0 });
    $(this.panelsInner).css({ position: `absolute` });
  }

  onClickTrigger(e, $) {
    const trigger = $(e.currentTarget);
    const isOpen = trigger.attr("aria-expanded") === "true";
    const triggerHeading = trigger.parents("h3");
    const panel = $(this.block).find(`#${trigger.attr("aria-controls")}`);
    // console.log({ trigger, isOpen, triggerHeading, panel });
    const otherTriggers = triggerHeading
      .siblings("h3")
      .find(".wp-block-seven-shapes-accordeon-simple__trigger");
    const otherPanels = panel.siblings(
      ".wp-block-seven-shapes-accordeon-simple__panel"
    );

    if (isOpen) {
      trigger.attr("aria-expanded", "false");
      panel
        .addClass("wp-block-seven-shapes-accordeon-simple__panel--hidden")
        .find("button, [href], input, select, textarea")
        .attr("tabIndex", "-1");
      panel.css({ flexBasis: 0 });

      return;
    }

    trigger.attr("aria-expanded", "true");
    panel
      .removeClass("wp-block-seven-shapes-accordeon-simple__panel--hidden")
      .find("button, [href], input, select, textarea")
      .removeAttr("tabIndex");
    otherTriggers.attr("aria-expanded", "false");
    otherPanels
      .addClass("wp-block-seven-shapes-accordeon-simple__panel--hidden")
      .find("button, [href], input, select, textarea")
      .attr("tabIndex", "-1");

    const currentPanelHeight = $(panel)
      .find(".wp-block-seven-shapes-accordeon-simple__panel-inner")
      .outerHeight();
    panel.css({ flexBasis: currentPanelHeight });
    otherPanels.css({ flexBasis: 0 });
  }
}
